import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './mortgage/containers/error/error.component';
import { LoginSecondHolderComponent } from './mortgage/containers/login-second-holder/login-second-holder.component';
import { SummarySecondHolderComponent } from './mortgage/containers/summary-second-holder/summary-second-holder.component';
import { LoggedGuard } from './shared/guards/logged/logged.guard';
import { OpenLoginGuard } from './shared/guards/open-login.guard';
import { SummarySecondHolderGuard } from './shared/guards/summary-second-holder/summary-second-holder.guard';
import {
  ERROR_NAME,
  HOME_NAME,
  LAYOUT_NAME,
  LOGIN_NAME,
  LOGIN_SECOND_HOLDER,
  PRE_SIMULATOR_NAME,
  SUMMARY_SECOND_HOLDER,
} from './shared/utils/constants';

const routes: Routes = [
  {
    path: HOME_NAME,
    pathMatch: 'full',
    redirectTo: PRE_SIMULATOR_NAME,
  },
  {
    path: LAYOUT_NAME,
    loadChildren: () =>
      import('./mortgage/mortgage.module').then((m) => m.MortgageModule),
  },
  {
    path: PRE_SIMULATOR_NAME,
    loadChildren: () =>
      import('./pre-simulator/pre-simulator.module').then((m) => m.PreSimulatorModule),
    canActivate: [LoggedGuard],
  },
  {
    path: LOGIN_NAME,
    loadChildren: () =>
      import('./pre-simulator/pre-simulator.module').then((m) => m.PreSimulatorModule),
    canActivate: [LoggedGuard, OpenLoginGuard],
  },
  {
    path: ERROR_NAME,
    component: ErrorComponent,
  },

  {
    path: LOGIN_SECOND_HOLDER,
    component: LoginSecondHolderComponent,
    canActivate: [LoggedGuard],
  },
  {
    path: SUMMARY_SECOND_HOLDER,
    component: SummarySecondHolderComponent,
    canActivate: [SummarySecondHolderGuard],
  },
  {
    path: '**',
    redirectTo: PRE_SIMULATOR_NAME,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
